import { render, staticRenderFns } from "./PassengerShip.vue?vue&type=template&id=d7e2ebda&scoped=true&"
import script from "./PassengerShip.vue?vue&type=script&lang=js&"
export * from "./PassengerShip.vue?vue&type=script&lang=js&"
import style0 from "./PassengerShip.vue?vue&type=style&index=0&id=d7e2ebda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e2ebda",
  null
  
)

export default component.exports